import { TranslationKey } from '@Localization';

const ServerErrorCodes: Record<string, TranslationKey> = {
  duplicate_user_name: 'user_name_is_duplicated',
};

const TranslateServerErrorCode = (serverErrorCode: TranslationKey): TranslationKey => {
  return ServerErrorCodes[serverErrorCode] || serverErrorCode;
};

export const TranslateServerErrorCodes = (serverErrorCodes: TranslationKey[]): TranslationKey[] => {
  const translatedErrorCodes: TranslationKey[] = [];
  serverErrorCodes.forEach((e) => translatedErrorCodes.push(TranslateServerErrorCode(e)));
  return translatedErrorCodes;
};
